/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_App_Block_SubtitleInputs */

const en_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduce mindless scrolling time!`)
};

const ar_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قلل وقت التمرير بلا هدف!`)
};

const de_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduzieren Sie Ihre sinnlose Scroll-Zeit !`)
};

const es_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduce el tiempo de desplazamiento sin pensar !`)
};

const fr_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduisez le temps de scroll machinal !`)
};

const it_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduci il tempo di scroll automatico !`)
};

const ja_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無意識なスクロール時間を減らそう ！`)
};

const ko_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무의식적 스크롤 시간을 줄이세요 !`)
};

const pt_br_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduza o tempo de rolagem automática !`)
};

const ru_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сократите время бессмысленного скроллинга !`)
};

const th_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลดเวลาการปัดหน้าจอแบบไร้จุดหมาย !`)
};

const tr_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düşünmeden kaydırma süresini azaltın !`)
};

const zh_cn_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减少习惯性刷手机的时间！`)
};

const zh_tw_subscription_exclusive_feature_app_block_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`減少習慣性滑手機的時間！`)
};

/**
* | output |
* | --- |
* | "Reduce mindless scrolling time!" |
*
* @param {Subscription_Exclusive_Feature_App_Block_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_app_block_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_App_Block_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_App_Block_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_app_block_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_app_block_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_app_block_subtitle(inputs)
});